import configs from '@/configs'

const offsets = {
    account: 5,
    'approval.flow': 6,
    'capex.planning': 20,
    'cash.flow': 24,
    client: 1,
    comment: 15,
    customer: 10,
    'dynamic.report': 21,
    event: 13,
    integration: 23,
    message: 3,
    'opex.planning': 19,
    organization: 4,
    payment: 11,
    'pl.planning': 22,
    product: 9,
    purchase: 16,
    'purchase.planning': 17,
    'sales.area': 12,
    'sales.planning': 14,
    security: 2,
    unit: 8,
    user: 0,
    vendor: 7,
    websocket: 26,
}

export default function getApiLocalPort(path) {
    const base = configs.api_port || 8000
    const offset = offsets[path]

    if (offset !== undefined) {
        return base + offset
    }
}
